// config
import * as http from 'utils/http';
import config from 'config';

const updateQuoteDetail = async ({ ticketId, quoteId, updateQuoteDetailDto }) => {
  return http.post(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/${quoteId}/operation-details/`,
    updateQuoteDetailDto
  );
};

export default updateQuoteDetail;
